import React, { useState } from 'react'
import DataForm from './DataForm'
import DataViewTable from './DataViewTable'
import DataPageHeader from './DataPageHeader'
import { DataFormVal, IDataForm } from '../../models/Pharse2/Data';
import { useStore } from '../../stores/store';

export default function DataPage() {
  const [record, setRecord] = useState<IDataForm>(new DataFormVal());
const {dataStore, graphStore} = useStore();

  const handleExportCurrent = ()=>{
    if(record.locationId>0 ){
      dataStore.exportCurrentLocation(record);
    }
  }

  const handleExportAll = ()=>{
    if(record.projectId > 0){
      // Not export all locations in one batch, the file may fail to download.
      // dataStore.exportAllLocations(record);

      // Create the locations IDs and export an excel file for each ID    
      graphStore.getlocationList(record.projectId).then(i => {
          if (i) {
            console.dir(i)
            for (let j = 0; j < i.length; j++) { // loop through the list of location IDs. Export an excel file for each ID.
              const {id, name} = i[j]
              if (!name.includes('no loggerset')) {
                dataStore.exportCurrentLocation(new DataFormVal({
                    ...record,
                    locationId: id
                  })
                  ,name +'.xlsx'
                )
              }
            }
          }
      })
    }
  }

  return (
    <div className="pageParentDiv ">
     <DataPageHeader allBtnisDisabled={record.projectId <= 0} currentBtnisDisabled={record.locationId<=0} exportAll={handleExportAll} exportCurrent={handleExportCurrent} />
      <DataForm record={record} setRecord={setRecord} />
      <DataViewTable />
    </div>
  )
}
